import script from "./QRCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCode.vue?vue&type=script&setup=true&lang=ts"

import "./QRCode.vue?vue&type=style&index=0&id=761e7df4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761e7df4"]])

export default __exports__